<app-page-header></app-page-header>
<app-breadcromb pageName="Work Experience"></app-breadcromb>
<!-- Candidate Dashboard Area Start -->
<section class="candidate-dashboard-area section_70">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 col-md-12 dashboard-left-border">
                <div class="dashboard-left">
                    <app-client-dashboard-sidebar></app-client-dashboard-sidebar>
                </div>
            </div>
            <div class="col-lg-9 col-md-12">
                <div class="dashboard-right">
                    <div class="candidate-profile">
                        <div class="candidate-single-profile-info">
                            <form #userForm="ngForm" (ngSubmit)="onSubmit(userForm.value)">
                                <div class="resume-box">
                                    <h3>Work Experience</h3>
                                    <div class="single-resume-feild feild-flex-2 ">
                                        <div class="single-input">
                                            <label for="program">industry Sector:</label><span class="ng-star-inserted"> *</span>
                                            <select required #type="ngModel" ngModel name="industry">
                              <option *ngFor="let industry of industrySectors" value="{{industry.name}}">{{industry.name}}</option>
                           </select>
                                            <span *ngIf="type.invalid && type.touched" class="error" style="color: red;">Industry Sector is required</span>
                                        </div>
                                        <div class="single-input">
                                            <label for="Phone">Company:</label><span class="ng-star-inserted"> *</span>
                                            <input required #company="ngModel" ngModel type="text" maxlength="254" name="company">
                                            <span *ngIf="company.invalid && company.touched" class="error" style="color: red;">company is required</span>
                                        </div>
                                    </div>
                                    <div class="single-resume-feild feild-flex-2">
                                        <div class="single-input">
                                            <label for="program">Job Caterogy :</label><span class="ng-star-inserted"> *</span>
                                            <select required #jobCategory="ngModel" ngModel name="jobCategory">
                                              <option *ngFor="let jobCategory of jobCategories" value="{{jobCategory.name}}">{{jobCategory.name}}</option>
                                            </select>
                                            <span *ngIf="jobCategory.invalid && jobCategory.touched" class="error" style="color: red;">Job Category is required</span>
                                        </div>
                                        <div class="single-input">
                                            <label for="Phone">Job Title:</label><span class="ng-star-inserted"> *</span>
                                            <input required #title="ngModel" ngModel type="text" maxlength="254" name="jobTitle">
                                            <span *ngIf="title.invalid && title.touched" class="error" style="color: red;">job title is required</span>
                                        </div>
                                    </div>

                                    <div class="single-resume-feild feild-flex-2">
                                        <div class="single-input">
                                            <ul>
                                                <li class="checkbox">
                                                    <input class="checkbox-spin" ngModel [ngModel]="!present" name="currentJob" type="checkbox" id="presentWork" (change)="onChange($event.target.checked ? 'on' : 'off')" />
                                                    <label for="presentWork"><span></span>I am currently working in this role.</label>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="single-input">
                                            <label for="Phone">Country:</label><span class="ng-star-inserted"> *</span>
                                            <input required #country="ngModel" ngModel type="text" maxlength="254" name="country">
                                            <span *ngIf="country.invalid && country.touched" class="error" style="color: red;">country is required</span>
                                        </div>
                                    </div>

                                    <div class="single-resume-feild feild-flex-2">
                                        <div class="single-input">
                                            <label for="datepicker_form2">From:</label><span class="ng-star-inserted"> *</span>
                                            <input required #syr="ngModel" ngModel type="date" max="{{todayDate|date:'yyyy-MM-dd'}}" name="startYear">
                                            <span *ngIf="syr.invalid && syr.touched" class="error" style="color: red;">start year is required</span>
                                        </div>
                                        <div class="single-input" *ngIf="present">
                                            <label for="datepicker_to2">To:</label><span class="ng-star-inserted"> *</span>
                                            <input required #enyr="ngModel" ngModel type="date" max="{{todayDate|date:'yyyy-MM-dd'}}" name="endYear">
                                            <span *ngIf="enyr.invalid && enyr.touched" class="error" style="color: red;">end year is required</span>
                                        </div>
                                        <div class="single-input" *ngIf="!present">
                                            <label>To:</label><br> Present
                                        </div>
                                    </div>
                                    <div class="single-resume-feild feild-flex-2">
                                        <div class="single-input">
                                            <label for="Phone">Awards:</label>
                                            <textarea ngModel name="awards"></textarea>
                                        </div>
                                        <div class="single-input">
                                            <label for="Phone">Achievements:</label>
                                            <textarea ngModel name="achievements"></textarea>
                                        </div>
                                    </div>
                                    <div class="single-resume-feild ">
                                        <div class="single-input">
                                            <label for="Phone">Duties:</label><span class="ng-star-inserted"> *</span>
                                            <textarea required #duties="ngModel" ngModel name="duties"></textarea>
                                            <span *ngIf="duties.invalid && duties.touched" class="error" style="color: red;">duties are required</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="submit-resume">
                                    <button [disabled]="userForm.invalid" class="btn btn-success">Save</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Candidate Dashboard Area End -->
